<script setup lang="ts">
import { ReservationDialogV2 } from "~/components/reservation"
import { ThemeButton } from "~/components/theme"
</script>

<template>
    <div class="fixed bottom-0 left-0 right-0 w-full z-100 border-b border-primary-foreground">
        <ReservationDialogV2>
            <ThemeButton
                size="lg"
                class="w-full h-14 rounded-b-none bg-primary text-primary-foreground hover:bg-primary/80"
            >
                <span>Reservations</span>
            </ThemeButton>
        </ReservationDialogV2>
    </div>
</template> 
